import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { workProcess } from '../cherrySoftwareContent';
import { StackIllustration } from './cherrySoftwareIllustrations';
import SectionHeader from './SectionHeader';
import IconBadge from './IconBadge';

const Process = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <Grid container spacing={4} alignItems="center" mb={{ xs: 2, md: 4 }}>
        <Grid item xs={12} md={7}>
          <SectionHeader
            overline={workProcess.overline}
            title={workProcess.title}
            subtitle={workProcess.subtitle}
            icon="timeline"
            align="left"
            maxWidth="100%"
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Box data-aos="fade-left" display="flex" justifyContent="center">
            <StackIllustration
              primary={theme.palette.primary.main}
              secondary={theme.palette.secondary.main}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {workProcess.steps.map((item, index) => (
          <Grid item xs={12} md={4} key={item.title} data-aos="fade-up">
            <Box
              sx={{
                height: '100%',
                p: 3,
                borderRadius: 3,
                position: 'relative',
                overflow: 'hidden',
                bgcolor: alpha(theme.palette.common.white, 0.9),
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: `0 14px 36px ${alpha(theme.palette.common.black, 0.05)}`,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: -20,
                  right: -20,
                  width: 90,
                  height: 90,
                  borderRadius: '50%',
                  bgcolor: alpha(
                    theme.palette[index === 1 ? 'secondary' : 'primary'].main,
                    0.08,
                  ),
                }}
              />
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <IconBadge icon={item.icon} variant="gradient" size={48} rounded="14px" />
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 800,
                    px: 1.25,
                    py: 0.5,
                    borderRadius: 999,
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    color: theme.palette.primary.main,
                  }}
                >
                  {item.phase}
                </Typography>
              </Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 800 }}>
                {item.title}
              </Typography>
              <Typography color="textSecondary" variant="body2" sx={{ lineHeight: 1.75 }}>
                {item.subtitle}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Process;
